import { getHiddenElementHeight } from '../_helper/element-helper';

let $imageOverlays = null;

function registerEventListeners($imageOverlay) {
    const $text = $imageOverlay.querySelector('.js-text-slideup');
    const textHeight = getHiddenElementHeight($text);

    $imageOverlay.addEventListener('mouseover', () => {
        $text.style.height = `${textHeight}px`;
    });

    $imageOverlay.addEventListener('mouseout', () => {
        $text.style.height = '0';
    });
}

const initialize = () => {
    $imageOverlays = document.body.querySelectorAll('.sm-image-overlay[data-sm-text-slideup]');

    if (!$imageOverlays) {
        return;
    }

    Array.prototype.forEach.call($imageOverlays, $imageOverlay => {
        registerEventListeners($imageOverlay);
    });
};

export default () => {
    initialize();
};
